import React from "react";
import { cx } from "emotion";
import { CLASSNAME_PREFIX } from "./classname";
import "../../Styles/Modal.scss";
import ElementSpacer from "../ElementSpacer";

export const ModalFooter: React.FC<React.HTMLProps<HTMLDivElement>> = props => (
  <div className={cx(`${CLASSNAME_PREFIX}footer`, props.className)} {...props}>
    <ElementSpacer>{props.children}</ElementSpacer>
  </div>
);
